import { hasVariantCapability } from '../../capability-matrix';

import type { SupervisionAlertVM, SupervisorVariant } from '../../view-models';
import type React from 'react';

export interface SupervisionAlertsColumnProps {
  alerts: SupervisionAlertVM[];
  variant: SupervisorVariant;
  onNavigate?: (target: string) => void;
}

/**
 * Uma linha de alerta. Com `link` → é um `<button>` que navega de verdade.
 * Sem `link` (alerta sem tela dedicada) → é um `<div>` NÃO-interativo: não finge
 * ser clicável (sem role button, sem cursor/hover de ação — modificador `--static`).
 */
function AlertRow({
  alert,
  onNavigate,
}: {
  alert: SupervisionAlertVM;
  onNavigate?: (target: string) => void;
}): React.JSX.Element {
  const cls =
    'supervision-col__row' +
    (alert.danger === true ? ' supervision-col__row--danger' : '') +
    (alert.link === undefined ? ' supervision-col__row--static' : '');
  const inner = (
    <>
      <div>
        <div className="supervision-col__row-label">{alert.label}</div>
        {alert.sub !== undefined && <div className="supervision-col__row-sub">{alert.sub}</div>}
      </div>
      <span className="supervision-col__row-count">{alert.count}</span>
    </>
  );

  if (alert.link === undefined) {
    return <div className={cls}>{inner}</div>;
  }
  const link = alert.link;
  return (
    <button
      type="button"
      className={cls}
      onClick={() => {
        onNavigate?.(link);
      }}
    >
      {inner}
    </button>
  );
}

export function SupervisionAlertsColumn({
  alerts,
  variant,
  onNavigate,
}: SupervisionAlertsColumnProps): React.JSX.Element {
  const visible = alerts.filter((a) => a.cap === undefined || hasVariantCapability(a.cap, variant));
  const insightsGroup = visible.filter((a) => a.kind === 'insights');
  const rest = visible.filter((a) => a.kind !== 'insights');

  return (
    <aside className="supervision-col">
      <div className="tela1-col__title">Alertas e pendências de supervisão</div>
      {rest.map((a, i) => (
        <AlertRow key={i} alert={a} {...(onNavigate !== undefined ? { onNavigate } : {})} />
      ))}

      {insightsGroup.length > 0 && (
        <>
          <div className="supervision-col__divider" />
          <div className="tela1-col__title">Insights pendentes</div>
          {insightsGroup.map((a, i) => (
            <AlertRow key={i} alert={a} {...(onNavigate !== undefined ? { onNavigate } : {})} />
          ))}
        </>
      )}
    </aside>
  );
}
